import { Box, Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { Region } from "~/api/resources/Regions";
import { mediaThumbUrl } from "~/lib/media";
import { Link } from "@chakra-ui/next-js";
import { MarkdownOrHtml } from "../Text";

type MapCommunityCardProps = {
  region: Region;
};
export const MapCommunityCard = ({ region }: MapCommunityCardProps) => {
  const image = mediaThumbUrl(region.lead_media);
  return (
    <Flex
      flexDirection={{ base: "column", lg: "row-reverse" }}
      alignItems={{ base: "flex-start", lg: "center" }}
      w={{ base: "304px", lg: "563px" }}
    >
      <Flex
        w={{ base: "304px", lg: "224px" }}
      >
        <Image
          w={{ base: "304px", lg: "224px" }}
          h={{ base: "200px", lg: "300px" }}
          src={image}
          fallbackSrc="/StopFillerImage.jpg"
          alt="Stop Image"
          objectFit="cover"
        />
      </Flex>
      <Flex
        flexDirection="column"
        justifyContent={{ base: "space-between" }}
        p="24px"
        gap="16px"
      >
        {region.name && (
          <Heading fontSize={{ base: "xl", lg: "3xl" }}>{region.name}</Heading>
        )}
        {!!region.short_description && (
          <MarkdownOrHtml
            textProps={{
              noOfLines: { base: 4 },
              fontWeight: "thin",
              fontSize: { base: "sm" },
            }}
          >
            {region.short_description}
          </MarkdownOrHtml>
        )}
        {region.slug && (
          <Button
            size="sm"
            w="-moz-fit-content"
            as={Link}
            href={`communities/${region.slug}`}
          >
            Learn More
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
